document.documentElement.classList.add('js');
document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-menu-toggle]');
  if (!toggle) return;
  const nav = document.getElementById(toggle.getAttribute('aria-controls'));
  if (!nav) return;
  const open = toggle.getAttribute('aria-expanded') === 'true';
  toggle.setAttribute('aria-expanded', String(!open));
  nav.hidden = open;
  if (!open) nav.querySelector('a')?.focus();
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const toggle = document.querySelector('[data-menu-toggle][aria-expanded="true"]');
  if (!toggle) return;
  const nav = document.getElementById(toggle.getAttribute('aria-controls'));
  if (!nav) return;
  toggle.setAttribute('aria-expanded', 'false');
  nav.hidden = true;
  toggle.focus();
});
